import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Facebook32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={chroma === 'dark' ? `${icon}-32-solid` : `${icon}-32`}
  >
    <path
      d="M20.818 12.754h-4.051V9.797c0-.907.938-1.117 1.376-1.117h2.617V4.69l-3-.016c-4.092 0-5.026 2.975-5.026 4.883v3.197h-2.97v4.112h2.97v11.1h4.033v-11.1h3.426l.625-4.112z"
      fillRule="evenodd"
    />
  </svg>
);

export default Facebook32;
